module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/aiCreation/components/AiVideoItem/asset/pen.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/aiCreation/components/AiVideoItem/asset/pen.png
// module id = 1726
// module chunks = 367